module.exports = __webpack_public_path__ + "img/salepoint.0d8ef804.png";